<template>
  <div>
    <button-default
      class="page_header--new_lead_button"
      icon-left="plus"
      @click="$refs.newRecordModal.open()"
    >
      New Lead
    </button-default>

    <modal-container>
      <modal-crud-form
        ref="newRecordModal"
        title="Lead"
        form-component="record-form"
        :width="600"
        include-create-and-view-record
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
export default {
  name: "PageHeaderNewRecord",
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.page_header {

  &--new_lead_button {
    margin-right: 20px;
  }
}
</style>
